import { camelCase } from 'lodash';
import { parseString } from 'xml2js';

var normalizeMiddleware = function normalizeMiddleware(callback) {
  var normalizer = function normalizer(element) {
    var tagName = element['#name'];

    if (tagName === '__text__') {
      return {
        tagName: '',
        attributes: {},
        text: element._
      };
    }

    return {
      tagName: element['#name'],
      attributes: element.$ || {},
      children: (element.$$ || []).map(normalizer)
    };
  };

  return function (error, result) {
    callback(error, error ? result : normalizer(result));
  };
};

export var parseXml = function parseXml(xml, callback) {
  return parseString(xml, {
    attrNameProcessors: [camelCase],
    charsAsChildren: true,
    explicitArray: true,
    explicitChildren: true,
    explicitRoot: false,
    mergeAttrs: false,
    normalizeTags: true,
    preserveChildrenOrder: true,
    trim: true
  }, normalizeMiddleware(callback));
};